"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTest = void 0;
/**
 * @returns true if the current process is running in a test environment.
 */
var isTest = function () {
    var _a;
    if (typeof process !== 'undefined') {
        return ((_a = process.env) === null || _a === void 0 ? void 0 : _a.NODE_ENV) === 'test';
    }
    return false;
};
exports.isTest = isTest;
//# sourceMappingURL=isTest.js.map